// extracted by mini-css-extract-plugin
export var banner = "_30-0";
export var icon = "_30-1";
export var message = "_30-2";